/**
 * CostSummaryCard Component
 * 
 * Display cost breakdown for campaign
 */

import React from 'react';
import { DollarSign } from 'lucide-react';
import { Card } from '../ui/card';

const CostSummaryCard = ({ totalAppointments, upfrontCost }) => {
  return (
    <Card className="bg-gradient-to-br from-gray-800 to-gray-800/50 border-gray-700 p-6">
      <div className="flex items-start gap-4">
        <div className="p-3 bg-[#3AD0E6]/10 rounded-lg">
          <DollarSign className="w-6 h-6 text-[#3AD0E6]" />
        </div>
        
        <div className="flex-1">
          <h3 className="text-lg font-medium text-white mb-4">Cost Summary</h3>
          
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-gray-400">Total Appointments:</span>
              <span className="text-white font-medium">{totalAppointments.toLocaleString()}</span>
            </div>
            
            <div className="flex items-center justify-between">
              <span className="text-gray-400">Cost per appointment:</span>
              <span className="text-white font-medium">$0.50</span>
            </div>
            
            <div className="border-t border-gray-700 my-2"></div>
            
            <div className="flex items-center justify-between">
              <span className="text-lg font-medium text-white">Total Cost:</span>
              <span className="text-2xl font-bold text-[#3AD0E6]">
                ${upfrontCost.toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default CostSummaryCard;

